import { FunnelStatusName } from 'src/modules/shared/components/atoms/funnel-status-name';
import { type FC, useMemo } from 'react';
import { TagDropdown } from 'src/modules/shared/components/molecules/dropdowns/tag-dropdown';
import { type FunnelStatus } from 'src/api/generated';

interface StatusMoveDropdownProps {
  statuses: FunnelStatus[];
  onStatusSelect: (statusId: number) => void;
  isLoading?: boolean;
  trigger: React.ReactNode;
}

export const StatusMoveDropdown: FC<StatusMoveDropdownProps> = ({
  statuses,
  onStatusSelect,
  isLoading,
  trigger,
}) => {
  const dropdownOptions = useMemo(() => {
    return statuses.map((status) => ({
      id: status.id,
      content: (
        <FunnelStatusName
          name={status.name}
          outcome={status.terminalOutcome}
          icon="archive"
          showArchiveTooltip
        />
      ),
    }));
  }, [statuses]);

  return (
    <TagDropdown
      content={trigger}
      variant="primary"
      appearance="outline"
      size="xs"
      options={dropdownOptions}
      onOptionSelect={(option) => onStatusSelect(Number(option.id))}
      isLoading={isLoading}
    />
  );
};
